<style>
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
</style>
<div id="convenios-detail" class="convenios-detail">
    <div class="user-view-top-area">
        <h1 *ngIf="selectedNode">{{selectedGroupo}} - {{selectedNombre}}</h1>
        <div class="button-area">
            <button *ngIf="selectedGroupo && isTopButtonShow" (click)="editConvenios(null)" type="button" class="edit">Editar</button>
            <button *ngIf="selectedGroupo && isTopButtonShow && isEliminarActive" (click)="deleteConvenios(null)" type="button" class="delete">Eliminar</button>
            
            <mat-menu #submenu="matMenu" [overlapTrigger]="false">
                <a>
                    <button mat-menu-item>
                        <span>Control de accesos</span>
                    </button>
                </a>
                <a>
                    <button mat-menu-item>
                        <span>Listado de usuarios</span>
                    </button>
                </a>
            </mat-menu>
        </div>
    </div>
    <h4>Criterios list<button *ngIf="convenioId" mat-button (click)="openAgendaAddEdit(null)"><mat-icon>add</mat-icon></button></h4>
    <div class="convenios-table">
        <table aria-describedby="" mat-table [dataSource]="dataSource">

            <!-- Position Column -->
            <ng-container matColumnDef="position">
                <th mat-header-cell *matHeaderCellDef> Días de baja (Desde) </th>
                <td mat-cell *matCellDef="let element"> 
                    <input *ngIf="!element.isEdit" value="{{element.diasDesde}}" disabled>  <input type="number" *ngIf="element.isEdit" [(ngModel)]="element.diasDesde">                   
                    <mat-error *ngIf="checkMinAndMax(1,545,element.diasDesde)">
                        <span >
                            Introduce un valor entre 1 y 545
                        </span>                        
                    </mat-error>                      
                </td>         
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Días de baja (Hasta) </th>
                <td mat-cell *matCellDef="let element"> <input *ngIf="!element.isEdit" value="{{element.diasHasta}}" disabled> <input type="number"  *ngIf="element.isEdit" [(ngModel)]="element.diasHasta">
                    <mat-error *ngIf="checkMinAndMax(1,545,element.diasHasta)">
                        <span >
                            Introduce un valor entre 1 y 545
                        </span>                        
                    </mat-error>
                </td>            
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="weight">
                <th mat-header-cell *matHeaderCellDef> Complemento </th>
                <td mat-cell *matCellDef="let element"> <input *ngIf="!element.isEdit" value="{{element.complemento}}" disabled> 
                    <input type="number"  *ngIf="element.isEdit"  minlength="1" maxlength="100"  id="complemento"  name="complemento"  #complemento="ngModel" [(ngModel)]="element.complemento">
                
                    <mat-error *ngIf="checkMinAndMax(0,100,element.complemento) && element.complemento !=null">
                        <span >
                            Introduce un valor entre 0 y 100
                        </span>                        
                    </mat-error>

                </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="symbol">
                <th mat-header-cell *matHeaderCellDef> Duración de la baja (Desde) </th>
                <td mat-cell *matCellDef="let element"> <input *ngIf="!element.isEdit" value="{{element.bajasDesdeDias}}" disabled> <input type="number"  *ngIf="element.isEdit" [(ngModel)]="element.bajasDesdeDias">
                    <mat-error *ngIf="checkMinAndMax(1,545,element.bajasDesdeDias)">
                        <span >
                            Introduce un valor entre 1 y 545
                        </span>                        
                    </mat-error>
                </td>
            </ng-container>

            <ng-container matColumnDef="symbol2">
                <th mat-header-cell *matHeaderCellDef> Duración de la baja (Hasta) </th>
                <td mat-cell *matCellDef="let element"> <input *ngIf="!element.isEdit" value="{{element.bajasHastaDias}}" disabled> <input type="number"  *ngIf="element.isEdit" [(ngModel)]="element.bajasHastaDias">
                    <mat-error *ngIf="checkMinAndMax(1,545,element.bajasHastaDias)">
                        <span >
                            Introduce un valor entre 1 y 545
                        </span>                        
                    </mat-error>
                </td>
            </ng-container>

            <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element"> 
                    <button (click)="onClose(element)" *ngIf="element.isEdit" mat-button>
                        <mat-icon>close</mat-icon>
                    </button>
                    <button *ngIf="!element.isEdit"  (click)="onEdit(element)" mat-button>
                        <mat-icon>edit</mat-icon>
                    </button> 
                    <button *ngIf="element.isEdit" (click)="onSave(element)" mat-button>
                        <mat-icon>done</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
</div>